import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const MasooliatMadaniPaths: IPaths = {
  BimehNameh: {
    Detail: '/MasooliatMadani/Detail',
    Estelam: '/Masooliat/Madani/Estelam',
    Sodoor: '/Masooliat/Madani/Sodoor',
    ElhaghiyehSaderehDetail: '/Masooliat/Madani/ElhaghiyehSaderehDetail',
    ElhaghiyehHayeSadereh: '/Masooliat/Madani/ElhaghiyehHayeSadereh',
  },
};
